module.exports = __webpack_public_path__ + "static/media/model.79555aa2.png";